/**
 * © [2024] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import * as actionTypes from './ActionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

export const handleErrorMessagesReminderRecipe = (data) => ({
  type: actionTypes.HANDLE_ERROR_MESSAGE_RR,
  errorMessagesInRedux: data,
});
export const setReminderRecipeScreenTab = (data) => {
  return {
    type: actionTypes.REMINDER_RECIPE_SCREEN_TAB_DATA,
    reminderRecipeObj: data,
  };
};
export const setReminderUserList = (data) => {
  return {
    type: actionTypes.GET_REMINDER_USER_LIST,
    userList: data,
  };
};
export const dispatchSaveOrUpdate = (values) => {
  return {
    saveOrUpdateMessage: values,
    type: actionTypes.SAVE_OR_UPDATE_RR,
  };
};
export const dispatchFetchReminderRecipeList = (values) => {
  return {
    reminderRecipientList: values,
    type: actionTypes.GET_REMINDER_RECIPIENT_LIST,
  };
};
export const getReminderRecipientGridList = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_REMINDER_RECIPIENT_LIST, value)
    .then((response) => {
      const temObj =
        response?.data &&
        response?.data?.sysReminderResponse?.map((item) => {
          item.id = uuidv4();
          item.isUpdate = false;
          item.duplicateUserIdErr = false;
          item.templateName = item.templateId != '0' ? item.reminderTypeCd : '';
          return item;
        });
      dispatch(dispatchFetchReminderRecipeList(temObj));
    })
    .catch(() => {
      dispatch(dispatchFetchReminderRecipeList([]));
    });
};
export const getReminderUserData = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_REMINDER_USER_LIST, value)
    .then((response) => {
      dispatch(setReminderUserList(response?.data?.sysReminderResponse));
    })
    .catch(() => {
      dispatch(setReminderUserList([]));
    });
};
// eslint-disable-next-line consistent-return
export const postSaveOrUpdate = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.ADD_UPDATE_SYSTEM_REMINDER, value)
    .then((response) => {
      return dispatch(
        dispatchSaveOrUpdate({
          message: 'SUCCESS',
          ...response.data,
        })
      );
    })
    .catch(() => {
      dispatch(dispatchSaveOrUpdate('failed'));
    });
};
export const clearReduxReminderRecipientsScreen = () => (dispatch) => {
  dispatch(dispatchSaveOrUpdate(''));
  dispatch(setReminderUserList([]));
  dispatch(handleErrorMessagesReminderRecipe([]));
  dispatch(dispatchFetchReminderRecipeList([]));
  dispatch(setReminderRecipeScreenTab({}));
};
